import {
    //CONFIGURATION
    CONFIGURATION_REQUEST, CONFIGURATION_SUCCESS, CONFIGURATION_FAILURE, SET_CLIENT_CONTEXT,
    // SIGN IN TYPE
    SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE,
    // SIGN UP    
    SIGN_UP_REQUEST, SIGN_UP_SUCCESS, SIGN_UP_FAILURE,
    //SEGMENT_LIST
    SEGMENT_LIST_REQUEST, SEGMENT_LIST_SUCCESS, SEGMENT_LIST_FAILURE,
    //STORES_LIST
    STORES_LIST_REQUEST, STORES_LIST_SUCCESS, STORES_LIST_FAILURE,
    //RECENTLY BROWSE
    RECENTLY_BROWSE_REQUEST, RECENTLY_BROWSE_SUCCESS, RECENTLY_BROWSE_FAILURE,
    //BRAND LIST
    GET_BRAND_LIST_REQUEST, GET_BRAND_LIST_SUCCESS, GET_BRAND_LIST_FAILURE,
    //ORDERS LIST
    GET_ORDERS_LIST_REQUEST, GET_ORDERS_LIST_SUCCESS, GET_ORDERS_LIST_FAILURE,
    //LAST ORDER SEGMENT
    GET_LAST_ORDER_SEGMENT_REQUEST, GET_LAST_ORDER_SEGMENT_SUCCESS, GET_LAST_ORDER_SEGMENT_FAILURE,
    //ORDERS DETAIL
    GET_ORDERS_DETAIL_REQUEST, GET_ORDERS_DETAIL_SUCCESS, GET_ORDERS_DETAIL_FAILURE,
    //VIEW SUBSITUTION DETAIL
    VIEW_SUBSITUTION_DETAIL_REQUEST, VIEW_SUBSITUTION_DETAIL_SUCCESS, VIEW_SUBSITUTION_DETAIL_FAILURE,
    //SAVE PRODUCT CART
    SAVE_PRODUCT_CART_REQUEST, SAVE_PRODUCT_CART_SUCCESS, SAVE_PRODUCT_CART_FAILURE,
    //GET PRODUCT CART
    GET_PRODUCT_CART_REQUEST, GET_PRODUCT_CART_SUCCESS, GET_PRODUCT_CART_FAILURE,
    //GET SOS LIST
    GET_SOS_LIST_REQUEST, GET_SOS_LIST_SUCCESS, GET_SOS_LIST_FAILURE,
    //GET SOCIAL LINKS
    GET_SOCIAL_LINKS_REQUEST, GET_SOCIAL_LINKS_SUCCESS, GET_SOCIAL_LINKS_FAILURE,
    GET_PRODUCT_DETAILS_REQUEST, GET_PRODUCT_DETAILS_SUCCESS, GET_PRODUCT_DETAILS_FAILURE,

    GET_USERDATA_REQUEST, GET_USERDATA_SUCCESS, GET_USERDATA_FAILURE,

    LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE,

    TRIGGERS_LIST_UNDER_REQUEST, TRIGGERS_LIST_UNDER_SUCCESS, TRIGGERS_LIST_UNDER_FAILURE,

    TRIGGERS_UPDATE_REQUEST, TRIGGERS_UPDATE_SUCCESS, TRIGGERS_UPDATE_FAILURE,

    TRIGGERS_SINGLE_REQUEST, TRIGGERS_SINGLE_SUCCESS, TRIGGERS_SINGLE_FAILURE,

    TRIGGERS_DELETE_REQUEST, TRIGGERS_DELETE_SUCCESS, TRIGGERS_DELETE_FAILURE,

    TRIGGERS_CREATE_REQUEST, TRIGGERS_CREATE_SUCCESS, TRIGGERS_CREATE_FAILURE,

    FILTER_API_CALL, RESET_DATA, OPEN_MODAL, CLOSE_MODAL, CLOSE_ALL_MODALS

} from '../../actions/action-types';

import { getCurrentDate } from '../../../utils/dateUtils';
import { buildClientContext } from '../../../utils/clientContext';

// Get current date dynamically
const currentDateInfo = getCurrentDate();

const initialState = {
    clientContext: buildClientContext(),
    configurationData: null,
    configurationResponse: null,
    configurationLoading: false,
    configurationError: null,
    configurationLoaded: false,
    configurationInitialized: false,
    configurationLoadedAt: null,
    store_voucher_entry: [],
    company_session: {
        current_date: currentDateInfo.current_date_redux,
        current_date_1: currentDateInfo.current_date,
        financial_year: currentDateInfo.financialYear,
        start_financial_year: currentDateInfo.start_financial_year,
        end_financial_year: currentDateInfo.end_financial_year
    },
    servicesData: {},
    storesData: {},
    recentlybrowseData: {},
    productDetailData: null,
    productDetailResponse: null,
    productDetailLoading: false,
    productDetailError: null,
    productDetailRequestId: null,
    brandsData: {},
    ordersData: [],
    ordersDetail: {},
    lastOrderSegmentData: null,
    lastOrderSegmentResponse: null,
    lastOrderSegmentLoading: false,
    lastOrderSegmentError: null,
    sosListData: [],
    sosListResponse: null,
    sosListLoading: false,
    sosListError: null,
    socialLinksData: [],
    socialLinksResponse: null,
    socialLinksLoading: false,
    socialLinksError: null,
    viewSubsititutionDetailData: null,
    viewSubsititutionDetailLoading: false,
    viewSubsititutionDetailError: null,
}

export const common = (state = initialState, { type, payload, meta }) => {
    switch (type) {
        case SET_CLIENT_CONTEXT:
            return {
                ...state,
                clientContext: {
                    ...state.clientContext,
                    ...(payload || {}),
                },
            }
        case CONFIGURATION_REQUEST:
            return {
                ...state,
                configurationLoading: true,
                configurationError: null,
            }
        case CONFIGURATION_SUCCESS:
            return {
                ...state,
                configurationData: payload?.data || payload || null,
                configurationResponse: payload || null,
                configurationLoading: false,
                configurationError: null,
                configurationLoaded: true,
                configurationInitialized: true,
                configurationLoadedAt: new Date().toISOString(),
            }
        case CONFIGURATION_FAILURE:
            return {
                ...state,
                configurationLoading: false,
                configurationError: payload || true,
                configurationLoaded: false,
                configurationInitialized: true,
            }
        case FILTER_API_CALL: return {
            ...state, stock_summary_filter_api: payload
        }
        // For SERVICE Module ===========================
        case SEGMENT_LIST_REQUEST:
            return {
                ...state, servicesData: null
            }
        case SEGMENT_LIST_SUCCESS:
            return {
                ...state, servicesData: payload.data || null,
            }
        case SEGMENT_LIST_FAILURE:
            return {
                ...state, servicesData: null
            }
        // For STORES Module ===========================
        case STORES_LIST_REQUEST:
            return {
                ...state, storesData: null
            }
        case STORES_LIST_SUCCESS:
            return {
                ...state, storesData: payload.data || null,
            }
        case STORES_LIST_FAILURE:
            return {
                ...state, storesData: null
            }
        // For RECENTLY_BROWSE_REQUEST Module ===========================
        case RECENTLY_BROWSE_REQUEST:
            return {
                ...state, recentlybrowseData: null
            }
        case RECENTLY_BROWSE_SUCCESS:
            return {
                ...state, recentlybrowseData: payload.data || null,
            }
        case RECENTLY_BROWSE_FAILURE:
            return {
                ...state, recentlybrowseData: null
            }    
        // For GET_BRAND_LIST_REQUEST Module ===========================
        case GET_BRAND_LIST_REQUEST:
            return {
                ...state, brandsData: null
            }
        case GET_BRAND_LIST_SUCCESS:
            return {
                ...state, brandsData: payload.data || null,
            }
        case GET_BRAND_LIST_FAILURE:
            return {
                ...state, brandsData: null
            }  

        case TRIGGERS_LIST_UNDER_REQUEST:
            return {
                ...state, group_all_list: []
            }
        case TRIGGERS_LIST_UNDER_SUCCESS:
            return {
                ...state, group_all_list: [{ id: 'Primary', name: 'Primary' }, ...payload.data] || [],
            }
        case TRIGGERS_LIST_UNDER_FAILURE:
            return {
                ...state, group_all_list: []
            }
        case TRIGGERS_CREATE_REQUEST:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_CREATE_SUCCESS:
            return {
                ...state, groupResponse: payload.data || null,
            }
        case TRIGGERS_CREATE_FAILURE:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_DELETE_REQUEST:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_DELETE_SUCCESS:
            return {
                ...state, groupResponse: payload.data || null,
            }
        case TRIGGERS_DELETE_FAILURE:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_SINGLE_REQUEST:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_SINGLE_SUCCESS:
            return {
                ...state, groupResponse: payload.data || null,
            }
        case TRIGGERS_SINGLE_FAILURE:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_UPDATE_REQUEST:
            return {
                ...state, groupResponse: null
            }
        case TRIGGERS_UPDATE_SUCCESS:
            return {
                ...state, groupResponse: payload.data || null,
            }
        case TRIGGERS_UPDATE_FAILURE:
            return {
                ...state, groupResponse: null
            }

        case GET_PRODUCT_DETAILS_REQUEST:
            return {
                ...state,
                productDetailData: null,
                productDetailResponse: null,
                productDetailLoading: true,
                productDetailError: null,
                productDetailRequestId: meta?.requestId || null,
            }
        case GET_PRODUCT_DETAILS_SUCCESS:
            if (meta?.requestId && state.productDetailRequestId !== meta.requestId) return state;
            return {
                ...state,
                productDetailData: payload?.data ?? null,
                productDetailResponse: payload ?? null,
                productDetailLoading: false,
                productDetailError: null,
            }
        case GET_PRODUCT_DETAILS_FAILURE:
            if (meta?.requestId && state.productDetailRequestId !== meta.requestId) return state;
            return {
                ...state,
                productDetailData: null,
                productDetailResponse: payload ?? null,
                productDetailLoading: false,
                productDetailError: payload ?? true,
            }

        case GET_LAST_ORDER_SEGMENT_REQUEST:
            return {
                ...state,
                lastOrderSegmentData: null,
                lastOrderSegmentResponse: null,
                lastOrderSegmentLoading: true,
                lastOrderSegmentError: null,
            }
        case GET_LAST_ORDER_SEGMENT_SUCCESS:
            return {
                ...state,
                lastOrderSegmentData: payload?.data ?? null,
                lastOrderSegmentResponse: payload ?? null,
                lastOrderSegmentLoading: false,
                lastOrderSegmentError: null,
            }
        case GET_LAST_ORDER_SEGMENT_FAILURE:
            return {
                ...state,
                lastOrderSegmentData: null,
                lastOrderSegmentResponse: payload ?? null,
                lastOrderSegmentLoading: false,
                lastOrderSegmentError: payload ?? true,
            }
        case GET_ORDERS_LIST_REQUEST:
            return {
                ...state, ordersData: []
            }
        case GET_ORDERS_LIST_SUCCESS:
            console.log("common state", payload.data)
            return {
                ...state, ordersData: payload.data || [],
            }
        case GET_ORDERS_LIST_FAILURE:
            return {
                ...state, ordersData: []
            }    
        case GET_ORDERS_DETAIL_REQUEST:
            return {
                ...state, ordersDetail: {}
            }
        case GET_ORDERS_DETAIL_SUCCESS:
            return {
                ...state, ordersDetail: payload.data || [],
            }
        case GET_ORDERS_DETAIL_FAILURE:
            return {
                ...state, ordersDetail: {}
            }  
        case GET_SOS_LIST_REQUEST:
            return {
                ...state,
                sosListLoading: true,
                sosListError: null,
            }
        case GET_SOS_LIST_SUCCESS:
            return {
                ...state,
                sosListData: payload?.data || [],
                sosListResponse: payload || null,
                sosListLoading: false,
                sosListError: null,
            }
        case GET_SOS_LIST_FAILURE:
            return {
                ...state,
                sosListData: [],
                sosListResponse: payload || null,
                sosListLoading: false,
                sosListError: payload || true,
            }
        case GET_SOCIAL_LINKS_REQUEST:
            return {
                ...state,
                socialLinksLoading: true,
                socialLinksError: null,
            }
        case GET_SOCIAL_LINKS_SUCCESS:
            return {
                ...state,
                socialLinksData: payload?.data?.social_links || [],
                socialLinksResponse: payload || null,
                socialLinksLoading: false,
                socialLinksError: null,
            }
        case GET_SOCIAL_LINKS_FAILURE:
            return {
                ...state,
                socialLinksData: [],
                socialLinksResponse: payload || null,
                socialLinksLoading: false,
                socialLinksError: payload || true,
            }
        case VIEW_SUBSITUTION_DETAIL_REQUEST:
            return {
                ...state,
                viewSubsititutionDetailData: null,
                viewSubsititutionDetailLoading: true,
                viewSubsititutionDetailError: null,
            }
        case VIEW_SUBSITUTION_DETAIL_SUCCESS:
            return {
                ...state,
                viewSubsititutionDetailData: payload || null,
                viewSubsititutionDetailLoading: false,
                viewSubsititutionDetailError: null,
            }
        case VIEW_SUBSITUTION_DETAIL_FAILURE:
            return {
                ...state,
                viewSubsititutionDetailData: null,
                viewSubsititutionDetailLoading: false,
                viewSubsititutionDetailError: payload || true,
            }
        case RESET_DATA:
            return { ...initialState };


        case OPEN_MODAL:
            return {
                ...state,
                modal_state: {
                    ...state.modal_state,
                    [payload]: true
                }
            };
        case CLOSE_MODAL:
            const newModalState = { ...state.modal_state };
            if (payload) {
                delete newModalState[payload];
            } else {
                return { ...state, modal_state: {} };
            }
            return {
                ...state,
                modal_state: newModalState,
            };
        case CLOSE_ALL_MODALS:
            return {
                ...state,
                modal_state: {}
            };
        default:
            return state
    }
}
